<div class="nsc-card-title" [class.nsc-card-title--error]="error">
  <h2 class="mat-title"[attr.aria-labelledby]="title"><ng-content></ng-content><span  class="nsc-card-title__note mat-caption" *ngIf="note">{{ note }}</span></h2>
  <!-- <h3></h3> -->
</div>
